import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UserImage } from '../../shared/models/user-image.model';
import { UserProfileState } from '../../store/user-profile/user-profile.state';

@Component({
  selector: 'app-header-user-info',
  templateUrl: './header-user-info.component.html',
  styleUrls: ['./header-user-info.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderUserInfoComponent implements OnInit {

  @Select(UserProfileState.getUserProfileImage) image$: Observable<UserImage>;

  @Input() firstName = '';
  @Input() fullName = '';
  viewModal = false;

  constructor() { }

  ngOnInit() { }

  toggleUserModal() {
    this.viewModal = !this.viewModal;
  }

}
